import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../../layouts';
import axios from 'axios';
import configBase from '../../../../../configBase';
import InputMask from 'react-input-mask';

import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Divider from '@material-ui/core/Divider';
import { PlaylistAdd as PlaylistAddIcon } from '@material-ui/icons';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';



class EscolherPlano extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showModalPlansChoice: true,
      fullScreenModal: false,

      optionSelect: 'null',
      disabledOption: false,
      optionList: [
        {
          value: "Pessoa Física",
          label: 'PESSOA FÍSICA'
        },
        /* {
          value: "Pessoa Jurídica",
          label: 'PESSOA JURÍDICA',
        }, */
        {
          value: "Servidor",
          label: 'SERVIDOR PÚBLICO'
        }
      ],
      
      localListFull: [],
      localList: [],
      disabledLocalSelect: false,
      localSelect: 'null',
      typePerson: false,
      citySelect: '',
      plans: false,
      msgErrorPlan: '',
      plansList: [],
      plansListFull: [],
      disabledPlansSelect: false,
      plansSelect: 'null',
      isServer: false,
      organList: [],
      organListFull: [],
      isCompanyS4e: false,
      companyS4List: [],
      check: {
        cnpj: true,
        code: false,
      },
      fields: {
        cnpj: {value: '', error: ''},
        code: {value: '', error: ''},
      },
      chosenCodeCompany: '',
      chosenNameCompany: '',
      
      showReservedMargin: false,
      answerReservedMargin: null,
      disabledButtonNextModal: true,
      
      errorRequest: false,
    };

  }

  componentDidMount() {
    // Verifica se o módulo de Funcionário Empresa tá habilitado
    if (configBase.moduloFuncEmpresa === true) {
      let state = this.state;
      state.optionList.push(
        {
					value: "Funcionário de Empresa",
					label: 'FUNCIONÁRIO DE EMPRESA'
				}
      );

      this.setState(state);
    }

    this.fullScreenModalFn();

    // Pega os agrupamentos
    axios.get(configBase.api + 'AgrupamentoUFs?access_token='+localStorage.getItem('planos_t'))
    .then((result) => {
      let state = this.state;

      if (result.data.length > 0) {
        state.localListFull = result.data;
        state.localList = [];

        for (let i = 0; i < result.data.length; i++) {
          state.localList.push({
            value: result.data[i].abrangenciaId,
            label: result.data[i].agrupamento
          });
        }
      }

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.disabledOption = false;
      this.setError('Problema encontrado ao buscar lista de Agrupamentos UF');
    }.bind(this));
  }

  fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960)
      state.fullScreenModal = false;
    else
      state.fullScreenModal = true;

    this.setState(state);
  }

  handleModalPlansChoiceCloseOn () {
    this.fullScreenModalFn();
    let state = this.state;
    state.showModalPlansChoice = true;
    this.setState(state);
  }

  handleModalPlansChoiceClose () {
    let state = this.state;
    state.showModalPlansChoice = false;
    this.setState(state);
  }

  optionChange(e) {
    let state = this.state;
    state.optionSelect = e.target.value;
    state.disabledOption = true;
    this.setState(state);

    if (e.target.value === 'Servidor') {
      state.isServer = false;
      state.answerReservedMargin = null;
      state.showReservedMargin = false;
      this.setState(state);

      axios.get(configBase.api + 'OrgaoAverbadors?filter={"where": {"status": "Ativo"}}&access_token='+localStorage.getItem('planos_t'))
      .then((result) => {
        
        state.organListFull = result.data;
        state.organList = [];

        for (let i = 0; i < result.data.length; i++) {
          state.organList.push({
            value: result.data[i].id,
            label: result.data[i].orgao
          });
        }

        state.isServer = true;
        state.plans = false;
        state.localSelect = 'null';
        state.citySelect = '';
        state.plansList = [];
        state.plansSelect = '';
        state.disabledOption = false;
        state.typePerson = false;
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.disabledOption = false;
        this.setError('Problema encontrado ao buscar lista de Orgão Averbador');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.optionSelect = e.target.value;
      state.answerReservedMargin = null;
      state.showReservedMargin = false;
      state.typePerson = true;
      state.plans = null;
      state.citySelect = 'null';
      state.plansList = [];
      state.plansSelect = 'null';
      state.isServer = false;
      state.organList = [];
      state.isCompanyS4e = false;
      state.disabledOption = false;
      this.setState(state);

      if (e.target.value === 'Funcionário de Empresa') {
        state.isCompanyS4e = true;
        state.typePerson = false;
        state.isServer = false;
        state.organList = [];
        state.plans = false;
        state.disabledOption = false;
        this.setState(state);
      }
    }
  }

  localChange(e) {
    let state = this.state;
    state.localSelect = e.target.value;
    state.disabledLocalSelect = true;
    state.answerReservedMargin = null;
    state.showReservedMargin = false;
    this.setState(state);

    let abrangenciaId = '';

    if (this.state.optionSelect === 'Servidor') {
      for (let i = 0; i < this.state.organListFull.length; i++) {
        if (e.target.value === this.state.organListFull[i].id) {
          abrangenciaId = this.state.organListFull[i].abrangenciaId;
          localStorage.setItem('planos_or', e.target.value);
        }
      }
    }
    else
      abrangenciaId = e.target.value;

      localStorage.setItem("planos_plandep", abrangenciaId + '|'+ this.state.optionSelect);

    axios.get(configBase.api + 'Plans?filter={"where":{"and":[{"abrangenciaId":"' + abrangenciaId + '"},{"publico":"' + this.state.optionSelect + '"}]}}&access_token='+localStorage.getItem('planos_t'))
    .then((result) => {
      if (result.data.length > 0) {
        state.plans = true;
        state.plansListFull = result.data;
        state.plansList = [];
        state.disabledLocalSelect = false;

        for (let i = 0; i < result.data.length; i++) {
          state.plansList.push({
            value: result.data[i].id,
            label: result.data[i].name + ' - ' + result.data[i].qualificacao + ' - ' + result.data[i].area_atuacao + ' - ' +
              result.data[i].registro + ' - R$ ' + result.data[i].value + ' - ' + result.data[i].cobertura
          });
        }

        state.plansSelect = "null";
      }
      else {
        let state = this.state;
        state.disabledCity = false;
        this.setError('Planos não encontrados dentro desse local de utilização selecionado');
      }

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.disabledLocalSelect = false;
      this.setError('Problema encontrado ao buscar lista de Planos');
    }.bind(this));
  }
  
  plansChange(e) {
    let state = this.state;
    state.plansSelect = e.target.value;

    if (this.state.optionSelect === 'Servidor' && configBase.margemReservada === true)
      state.showReservedMargin = true;
    else {
      if (this.props.showFormFn != null)
        state.disabledButtonNextModal = false;
    }

    this.setState(state);

    // Funcionário de Empresa
    if (this.state.isCompanyS4e === true) {
      localStorage.removeItem('planos_plan');
      localStorage.removeItem('planos_plandep');
      localStorage.setItem("planos_plan2", state.chosenCodeCompany + '|'+e.target.value);
    }
    else {
      localStorage.removeItem('planos_plan2');
      localStorage.setItem("planos_plan", e.target.value);

      let planosPlandep = localStorage.getItem('planos_plandep');
      if (planosPlandep !== null && planosPlandep !== 'null') {
        planosPlandep = planosPlandep.split('|');

        if (planosPlandep.length >= 2) {
          for (let i = 0; i < this.state.plansListFull.length; i++) {
            if (e.target.value.toString() === this.state.plansListFull[i].id.toString()) {
              planosPlandep = planosPlandep[0] + '|' + planosPlandep[1] + '|' + this.state.plansListFull[i].typePayment;

              localStorage.setItem("planos_plandep", planosPlandep);
              break;
            }
          }
        }
      }
    }
  }
  
  clickShowForm() {
    this.handleModalPlansChoiceClose();
    this.props.showFormFn();
  }

  reservedMarginOn () {
    let state = this.state;
    state.answerReservedMargin = true;
    this.setState(state);
    this.clickShowForm();
  }
  
  reservedMarginOff () {
    let state = this.state;
    state.answerReservedMargin = false;
    this.setState(state);
  }
  
  checkChange(event) {
    let state = this.state;
    state.fields.code.error = '';
    state.fields.cnpj.error = '';
    state.chosenNameCompany = '';

    if (event.target.name === 'cnpj') {
      if (state.check.cnpj === false) {
        state.plans = false;
        state.plansList = [];
        state.check[event.target.name] = event.target.checked;
        state.check.code = !event.target.checked;
      }
    }
    else {
      if (state.check.code === false) {
        state.plans = false;
        state.plansList = [];
        state.check[event.target.name] = event.target.checked;
        state.check.cnpj = !event.target.checked;
      }
    }

    this.setState(state);
  }

  fieldsChange(event) {
    let state = this.state;
    state.fields.code.error = '';
    state.fields.cnpj.error = '';
    state.fields[event.target.name].value = event.target.value;
    this.setState(state);
  }

  getPlanCompanyS4E(event) {
    event.preventDefault(event);

    let state = this.state;

    // CNPJ marcado
    if (this.state.check.cnpj === true) {
      if (this.state.fields.cnpj.value.replace(/[^\d]+/g,"").length === 0) {
        state.fields.cnpj.error = 'CNPJ da empresa é obrigatório';
        this.setState(state);
      }
      else {
        if (this.state.fields.cnpj.value.replace(/[^\d]+/g,"").length < 14) {
          state.fields.cnpj.error = 'CNPJ inválido';
          this.setState(state);
        }
        else {
          state.disabledCodeCnpj = true;
          this.setState(state);
          this.getCompanyS4E(this.state.fields.cnpj.value.replace(/[^\d]+/g,""), null);
        }
      }
    }
    // Código marcado
    else {
      if (this.state.fields.code.value.length === 0) {
        state.fields.code.error = 'Código da empresa é obrigatório';
        this.setState(state);
      }
      else {
        state.disabledCodeCnpj = true;
        this.setState(state);
        this.getCompanyS4E(null, this.state.fields.code.value);
      }
    }
  }

  getPlansCompanyCode(code) {
    let dataPost = {
      IdEmpresa: code.toString()
    };

    axios.post(configBase.api + 'APIS4s/Planos?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      if (result.data !== null) {
        if (result.data.length > 0) {
          let state = this.state;
          state.plans = true;
          state.plansList = [];
          state.disabledCodeCnpj = false;
          state.chosenCodeCompany = code;

          for (let i = 0; i < result.data.length; i++) {
            state.plansList.push({
              value: result.data[i].Id,
              label: result.data[i].Nome + ' - R$ ' + Number.parseFloat(result.data[i].ValorTitular).toFixed(2).replace('.', ',')
            });
          }

          state.plansSelect = "null";
          this.setState(state);
        }
        else {
          let state = this.state;
          state.plans = false;
          state.disabledCodeCnpj = false;
          state.disabledOption = false;
          this.setError('Planos não encontrados para esta empresa');
        }
      }
      else {
        let state = this.state;
        state.plans = false;
        state.disabledCodeCnpj = false;
        state.disabledOption = false;
        this.setError('Planos não encontrados para esta empresa');
      }
    })
    .catch(function () {
      let state = this.state;
      state.plans = false;
      state.disabledCodeCnpj = false;
      state.disabledOption = false;
      this.setError('Problema encontrado ao buscar planos da empresa');
    }.bind(this));
  }

  getCompanyS4E(cnpj=null, code=null) {
    let dataPost = null;

    if (cnpj !== null)
      dataPost = {"cnpjEmpresa": cnpj};
    else
      dataPost = {"IdEmpresa": code};

    axios.post(configBase.api + 'APIS4s/Empresas?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      if (result.data !== null) {
        if (result.data.length > 0) {
          let state = this.state;
          state.chosenNameCompany = result.data[0].NomeFantazia;

          if (result.data[0].NomeSituacao === 'CANCELADO') {
            state.plans = 'error';
            state.msgErrorPlan = 'Situação da empresa: '+result.data[0].NomeSituacao;
            state.disabledCodeCnpj = false;
            this.setState(state);
          }
          else {
            state.plans = false;
            state.msgErrorPlan = '';
            this.setState(state);
            this.getPlansCompanyCode(result.data[0].Id);
          }
        }
        else {
          let state = this.state;
          state.disabledOption = false;
          this.setError('Planos não encontrados para esta empresa');
        }
      }
      else {
        let state = this.state;
        state.plans = false;
        state.disabledCodeCnpj = false;
        state.disabledOption = false;
        this.setError('Planos não encontrados para esta empresa');
      }
    })
    .catch(function () {
      let state = this.state;
      state.plans = false;
      state.disabledCodeCnpj = false;
      state.disabledOption = false;
      this.setError('Problema encontrado ao buscar planos da empresa');
    }.bind(this));
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }


  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="incluirPropostaPf">
          <div id="incluirPropostaPfBarra">
            <Paper elevation={0} className="paper">
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <div id="incluirPropostaPfTitulo">
                    <Typography variant="button" gutterBottom style={{marginLeft: 6}}
                    >
                      INCLUIR PROPOSTA
                    </Typography>
                  </div>
                </Grid>

                {
                  this.state.showModalPlansChoice === false ? (
                <Grid item xs={12} sm={12} md={12} lg={8} className="barraBotao">
                  <div className="botoesDeEnvio">
                    <Button
                      variant="contained"
                      startIcon={<PlaylistAddIcon />}
                      size="small"
                      onClick={this.handleModalPlansChoiceCloseOn.bind(this)}
                      style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    >
                      ESCOLHER PLANO
                    </Button>
                  </div>
                </Grid>
                  ) : ('')
                }

              </Grid>
            </Paper>
          </div>
        </div>

        <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
          <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
            {this.state.msgErrorRequest}
          </MuiAlert>
        </Snackbar>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.showModalPlansChoice}
          onClose={this.handleModalPlansChoiceClose.bind(this)}
          aria-labelledby="i_incluirPropostaPf-title"
          aria-describedby="i_incluirPropostaPf-description"
        >
          <DialogTitle id="i_incluirPropostaPf-title">
            {"Preencha os campos abaixo para prosseguir"}
          </DialogTitle>

          <DialogContent>
            <div className="containerButton incluirPropostaPfLarguraModal" style={{marginTop: 20}}>
              <TextField
                fullWidth
                select
                label="Escolha uma opção"
                variant="outlined"
                size="small"
                name="optionSelect"
                SelectProps={{
                  native: true,
                }}
                value={this.state.optionSelect}
                disabled={this.state.disabledOption}
                onChange={this.optionChange.bind(this)}
              >
                <option value="null">Selecionar</option>
              {this.state.optionList.map((item, index) =>
                <option key={index} value={item.value}>{item.label}</option>
              )}
              </TextField>
              {
                this.state.disabledOption === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>

            {
              this.state.typePerson === true ? (
            <div className="containerButton incluirPropostaPfLarguraModal" style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                select
                label="Local de Utilização"
                variant="outlined"
                size="small"
                name="localSelect"
                SelectProps={{
                  native: true,
                }}
                value={this.state.localSelect}
                disabled={this.state.disabledLocalSelect}
                onChange={this.localChange.bind(this)}
              >
                <option value="null">Selecionar</option>
                {this.state.localList.map((item, index) =>
                  <option key={index} value={item.value}>{item.label}</option>
                )}
              </TextField>
              {
                this.state.disabledLocalSelect === true ? (
                  <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
              ) : ('')
            }

            {
              this.state.isServer === true ? (
            <div className="containerButton incluirPropostaPfLarguraModal" style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                select
                label="Órgão Averbador"
                variant="outlined"
                size="small"
                name="localSelect"
                SelectProps={{
                  native: true,
                }}
                value={this.state.localSelect}
                disabled={this.state.disabledLocalSelect}
                onChange={this.localChange.bind(this)}
              >
                <option value="null">Selecionar</option>
                {this.state.organList.map((item, index) =>
                  <option key={index} value={item.value}>{item.label}</option>
                )}
              </TextField>
              {
                this.state.disabledLocalSelect === true ? (
                  <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
              ) : ('')
            }

            {
					    this.state.isCompanyS4e === true ? (
            <div className="containerButton incluirPropostaPfLarguraModal" style={{marginTop: 20}}>
              <FormGroup>
                <Grid container spacing={0}>
                  <Grid item xs={6} sm={6} md={6} lg={6} style={{textAlign: 'center'}}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          style={{color: configBase.corPrincipal}}
                          checked={this.state.check.cnpj}
                          onChange={this.checkChange.bind(this)}
                          name="cnpj"
                          color="primary"
                        />
                      }
                      label="CNPJ"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} style={{textAlign: 'center'}}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          style={{color: configBase.corPrincipal}}
                          checked={this.state.check.code}
                          onChange={this.checkChange.bind(this)}
                          name="code"
                          color="primary"
                        />
                      }
                      label="CÓDIGO"
                    />
                  </Grid>
                </Grid>

                <form onSubmit={this.getPlanCompanyS4E.bind(this)}>
                  <Grid container spacing={0}>
                    <Grid item xs={11} sm={11} md={11} lg={11}>
                  {
                    this.state.check.cnpj === true ? (
                      <div className="containerButton">
                        <InputMask
                          mask="99.999.999/9999-99"
                          maskChar=" "
                          value={this.state.fields.cnpj.value}
                          onChange={this.fieldsChange.bind(this)}
                          disabled={this.state.disabledCodeCnpj}
                        >
                          {() => <TextField
                            fullWidth
                            label="PESQUISAR PELO CNPJ"
                            variant="outlined"
                            size="small"
                            name="cnpj"
                            error={this.state.fields.cnpj.error.length > 0 ? (true):(false)}
                            helperText={this.state.fields.cnpj.error}
                            disabled={this.state.disabledCodeCnpj}
                          />}
                        </InputMask>

                        {
                          this.state.disabledCodeCnpj === true ? (
                        <CircularProgress size={24} className="progressButton" />
                          ) : ('')
                        }
                      </div>
                    ) : (
                      <div className="containerButton">
                        <TextField
                          fullWidth
                          error={this.state.fields.code.error.length > 0 ? (true):(false)}
                          helperText={this.state.fields.code.error}
                          label="PESQUISAR PELO CÓDIGO"
                          type="tel"
                          variant="outlined"
                          size="small"
                          name="code"
                          value={this.state.fields.code.value}
                          onChange={this.fieldsChange.bind(this)}
                          disabled={this.state.disabledCodeCnpj}
                        />

                        {
                          this.state.disabledCodeCnpj === true ? (
                        <CircularProgress size={24} className="progressButton" />
                          ) : ('')
                        }
                      </div>
                    )
                  }
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1}>
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                        style={{bottom: 6}}
                        type="submit"
                        onClick={this.getPlanCompanyS4E.bind(this)}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Grid>
                  </Grid>

              {
                this.state.chosenNameCompany.length > 0 ? (
                  <Grid container spacing={0} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="button" display="block" gutterBottom>
                        Empresa: <strong>{this.state.chosenNameCompany}</strong>
                      </Typography>
                    </Grid>
                  </Grid>
                ) : ('')
              }
                </form>
              </FormGroup>
            </div>
              ) : ('')
            }

            {
              this.state.plans === true ? (
            <div className="containerButton incluirPropostaPfLarguraModal" style={{marginTop: 20}}>
              <TextField
                fullWidth
                select
                label="Lista de Planos Disponíveis"
                variant="outlined"
                size="small"
                name="plansSelect"
                SelectProps={{
                  native: true,
                }}
                value={this.state.plansSelect}
                disabled={this.state.disabledPlansSelect}
                onChange={this.plansChange.bind(this)}
              >
                <option value="null">Selecionar</option>
              {this.state.plansList.map((item, index) =>
                <option key={index} value={item.value}>{item.label}</option>
              )}
              </TextField>
              {
                this.state.disabledPlansSelect === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
              ) : (
                this.state.plans === 'error' ? (
            <div className="containerButton incluirPropostaPfLarguraModal">
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MuiAlert className="snackbarStyle" severity="error" variant="filled" elevation={6}>
                    {this.state.msgErrorPlan}
                  </MuiAlert>
                </Grid>
              </Grid>
            </div>
                ) : ('')
              )
            }

            {
              this.state.showReservedMargin === true ? (
            <div className="incluirPropostaPfLarguraModal" style={{marginTop: 20}}>
              <div>
                <Divider style={{marginBottom: 15}}/>
              </div>
              <Typography variant="h5" gutterBottom>
                Plano autorizado mediante reserva de margem
              </Typography>

              {
                this.state.answerReservedMargin === false ? (
                <Typography variant="overline" display="block" gutterBottom>
                  {configBase.margemReservadaMsg}
                </Typography>
                ) : (
                <Typography variant="button" display="block" gutterBottom>
                  MARGEM RESERVADA?
                </Typography>
                )
              }
            </div>
              ) : ('')
            }

          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleModalPlansChoiceClose.bind(this)} color="primary">
              CANCELAR
            </Button>
            {
              this.state.showReservedMargin === false ? (
            <Button
              onClick={this.clickShowForm.bind(this)}
              color="primary"
              disabled={this.state.disabledButtonNextModal}
            >
              AVANÇAR
            </Button>
              ) : (
                this.state.answerReservedMargin === false ? ('') : (
            <div>
              <Button
                onClick={this.reservedMarginOff.bind(this)}
                color="primary"
              >
                NÃO
              </Button>
              <Button
                onClick={this.reservedMarginOn.bind(this)}
                color="primary"
              >
                SIM
              </Button>
            </div>
                )
              )
            }
          </DialogActions>

        </Dialog>

      </MainLayout>
    );

  }

}

EscolherPlano.propTypes = {
  showFormFn: PropTypes.func
};

export default withRouter(EscolherPlano);